<div class="table-container">
  @if (csvDownloadEnabled && data.length > 0) {
    <div class="table-actions">
      <button mat-button (click)="downloadCsv()" class="download-csv-button">
        <mat-icon>download</mat-icon>
        {{ 'ADMIN.EXPORT_CSV' | translate }}
      </button>
    </div>
  }
  <div class="table-scroll-container">
    <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-table mat-elevation-z8" (matSortChange)="handleSortEvent($event)">
      @for (column of columns; track $index) {
        <ng-container [matColumnDef]="column.columnDef" [sticky]="column.sticky">
          @if (column.sortable) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ getHeader(column) | translate }}
            </th>
          } @else {
            <th mat-header-cell *matHeaderCellDef [class.highlighted]="column.highlight">
              {{ getHeader(column) | translate }}
            </th>
          }
          <td mat-cell *matCellDef="let element" [class.highlighted]="column.highlight">
            <app-paginated-table-cell [data]="column.cell(element)" [columnType]="column.type" [timezone]="timezone"></app-paginated-table-cell>
          </td>
          @if (displayFooterRow) {
            <td mat-footer-cell *matFooterCellDef [class.highlighted]="column.highlight">
              @let footerValue = getFooterValue(column);
              @if (footerValue !== null) {
                <app-paginated-table-cell [data]="footerValue" [columnType]="column.footerType ?? column.type" [timezone]="timezone"></app-paginated-table-cell>
              }
            </td>
          }
        </ng-container>
      }
      @if (displayActionsColumn) {
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'COMMON.ACTIONS' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="buttons">
            @if (generateEditLink !== null) {
              <a [routerLink]="generateEditLink(element)" queryParamsHandling="merge">
                <button mat-icon-button>
                  <mat-icon>edit</mat-icon>
                </button>
              </a>
            }
            @for (action of actions; track $index) {
              @if (action.icon) {
                <button mat-icon-button (click)="action.handle(element)" [matTooltip]="action.translationKey | translate">
                  <mat-icon>{{ action.icon }}</mat-icon>
                </button>
              } @else {
                <button mat-button (click)="action.handle(element)">{{ action.translationKey | translate }}</button>
              }
            }
          </td>
          @if (displayFooterRow) {
            <td mat-footer-cell *matFooterCellDef></td>
          }
        </ng-container>
      }
      <tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      @if (displayFooterRow) {
        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
      }
    </table>
  </div>
  @if (paginationEnabled) {
    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
    >
    </mat-paginator>
  }
</div>
